import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  id: "background",
  loop: "true",
  autoplay: "",
  muted: ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("source", {
  src: "background.mp4",
  type: "video/mp4"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "top",
  class: "flex"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "title",
    src: "Title.svg",
    alt: ""
  })
], -1)
const _hoisted_6 = { id: "content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  id: "repo",
  target: "_blank",
  class: "small",
  href: "https://github.com/Matthew-J-Spencer/Patreon"
}, "Repository", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "vignette" }, null, -1)

import { onMounted, inject, ref, computed } from "vue";
import Toast from "@/components/Toast.vue";
import { auth } from "@/assets/ts/firebase";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var router = useRouter();

var showLogout = ref(false);

onMounted(async () => {
  window.addEventListener("resize", () => {
    fetchHeight();
  });
  fetchHeight();
});

const fetchHeight = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

const logout = async () => {
  await auth.signOut();
  router.push("/authenticate");
};

auth.onAuthStateChanged((user) => (showLogout.value = user != null));

const iOS = () => {
  return (
    ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "background-container",
      class: _normalizeClass({ fallback: iOS() })
    }, [
      (!iOS())
        ? (_openBlock(), _createElementBlock("video", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true)
    ], 2),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createVNode(Toast),
    (_unref(showLogout))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "logout",
          class: "small",
          onClick: logout
        }, "Logout?"))
      : _createCommentVNode("", true),
    _hoisted_7,
    _hoisted_8
  ]))
}
}

})